import React, { ChangeEvent, useState } from 'react';
import { 
    Box, 
    Divider, 
    Flex, 
    Text, 
} from '@chakra-ui/react';
import CustomButton from '../../../components/ui/buttons/Button';
import CustomModal from '../../../components/ui/modals';
import FormInputText from "../../../components/ui/forms/FormInputText";

export default function AccountSignIn() {
    const [email, setEmail] = useState('sammyqqqqq@gmail.com');
    const [showChangeEmailModal, setShowChangeEmailModal] = useState(false)

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setEmail(e?.target?.value)
    }

    return (
        <Box paddingBottom='6'>
            <Flex marginTop={'4'} marginBottom={'4'} justifyContent={'space-between'} alignItems='center'>
                <Box>
                    <Text fontSize='sm' color='gray.700' fontWeight={'semibold'}>
                        Email Address + Password
                    </Text>
                    <Text fontSize={'sm'} color='gray.500'>{email}</Text>
                </Box>
                <Box>
                    <CustomButton 
                        type='button'
                        cta='outline' 
                        variant={'outline'}
                        size='sm'
                        colorScheme='blue'
                        label='Change email'
                        onClick={() => setShowChangeEmailModal(true)}
                    />
                </Box>
            </Flex>
            <Divider />
            {/*  Google */}
            <Flex marginTop={'4'} justifyContent={'space-between'} alignItems='center'>
                <Flex alignItems='center'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={{ fill: 'rgba(0, 0, 0, 1)', transform: ';msFilter:' }}>
                        <path d="M20.283 10.356h-8.327v3.451h4.792c-.446 2.193-2.313 3.453-4.792 3.453a5.27 5.27 0 0 1-5.279-5.28 5.27 5.27 0 0 1 5.279-5.279c1.259 0 2.397.447 3.29 1.178l2.6-2.599c-1.584-1.381-3.615-2.233-5.89-2.233a8.908 8.908 0 0 0-8.934 8.934 8.907 8.907 0 0 0 8.934 8.934c4.467 0 8.529-3.249 8.529-8.934 0-.528-.081-1.097-.202-1.625z"></path>
                    </svg> 
                    <Text marginLeft={'1'} fontSize={'sm'} color='gray.500'>Google</Text>
                </Flex>
                <Box>
                    <CustomButton 
                        type='button'
                        cta='outline' 
                        variant={'outline'}
                        size='sm'
                        colorScheme='blue'
                        label='Connect to Google'
                        onClick={() => setShowChangeEmailModal(true)}
                    />
                </Box>
            </Flex>

             {/* Add new document modal */}
             <CustomModal
                isOpen={showChangeEmailModal}
                onCloseFn={() => setShowChangeEmailModal(false)}
                isFooter={true}
                size={'sm'}
                headerTitle='Update email'
                footerPrimaryBtnLabel='Save'
                footerPrimaryBtnFn={() => setShowChangeEmailModal(false)}
                footerPrimaryBtnDisabled={!email.length}
            >
                <Box>
                    <FormInputText 
                        id='email'
                        name='email'
                        label="Sign-in email"
                        placeholder='Enter an email here'
                        value={email}
                        type="text" 
                        onChange={handleChange}
                    />  
                </Box>
            </CustomModal>
        </Box>  
    )
}